import React, { useRef, useState, useEffect } from "react";
import { IoIosArrowBack } from "react-icons/io";
import { FaCalendar } from "react-icons/fa";
import { useParams } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { setEventRecord, UseCaseeventListApi } from "../api/api";

function SetSeatdetection() {
  const imageRef = useRef(null);
  const canvasRef = useRef(null);
  const id = useParams();
  const [useCaseId, setUseCaseId] = useState("");
  const [useCase, setUseCase] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [name, setName] = useState("");
  const [Eventname, setEventName] = useState("");
  const [currentPolygon, setCurrentPolygon] = useState([]);
  const [polygons, setPolygons] = useState([]);
  const [drawingEnabled, setDrawingEnabled] = useState(false);
  const [polygonCount, setPolygonCount] = useState(1);

  const closeThreshold = 10;

  const fetchUseCase = async () => {
    try {
      const data = await UseCaseeventListApi();
      if (data?.data?.status === true) {
        setUseCase(data?.data?.data);
      }
    } catch (error) {
      //console.log("error", error);
    }
  };

  useEffect(() => {
    fetchUseCase();
  }, []);

  const isCloseToFirstPoint = (p1, p2) => {
    const dx = p1[0] - p2[0];
    const dy = p1[1] - p2[1];
    return Math.sqrt(dx * dx + dy * dy) < closeThreshold;
  };

  const handleMouseDown = (e) => {
    if (!drawingEnabled) return;

    const rect = canvasRef.current.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    const clickedPoint = [x, y];

    if (
      currentPolygon.length >= 3 &&
      isCloseToFirstPoint(clickedPoint, currentPolygon[0])
    ) {
      if (!name.trim()) {
        alert("Please enter a polygon name.");
        return;
      }

      const newPolygon = {
        polygon_name: name.trim(),
        points: currentPolygon,
      };

      setPolygons([...polygons, newPolygon]);
      setCurrentPolygon([]);
      setPolygonCount(polygonCount + 1);
      setName("");
      setDrawingEnabled(false);
    } else {
      setCurrentPolygon([...currentPolygon, clickedPoint]);
    }
  };

  const handleMouseMove = (e) => {
    if (!drawingEnabled || currentPolygon.length === 0) return;

    const rect = canvasRef.current.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    const ctx = canvasRef.current.getContext("2d");
    ctx.clearRect(0, 0, canvasRef.current.width, canvasRef.current.height);
    drawAllPolygons();
    drawPreviewPolygon([...(currentPolygon || []), [x, y]]);
  };

  const drawPolygon = (points, color = "blue", label = "") => {
    const ctx = canvasRef.current.getContext("2d");
    if (points.length < 2) return;

    ctx.beginPath();
    ctx.moveTo(points[0][0], points[0][1]);
    points.forEach(([x, y]) => ctx.lineTo(x, y));
    ctx.closePath();

    ctx.fillStyle = "rgba(0, 0, 255, 0.2)";
    ctx.fill();
    ctx.strokeStyle = color;
    ctx.lineWidth = 2;
    ctx.stroke();

    if (label) {
      const center = getPolygonCenter(points);
      ctx.fillStyle = "black";
      ctx.font = "14px Arial";
      ctx.fillText(label, center[0], center[1]);
    }
  };

  const drawPreviewPolygon = (points) => {
    const ctx = canvasRef.current.getContext("2d");
    if (points.length < 2) return;

    ctx.beginPath();
    ctx.moveTo(points[0][0], points[0][1]);
    points.forEach(([x, y]) => ctx.lineTo(x, y));

    ctx.strokeStyle = "red";
    ctx.setLineDash([5, 5]);
    ctx.stroke();
    ctx.setLineDash([]);
  };

  const drawAllPolygons = () => {
    polygons.forEach((poly) =>
      drawPolygon(poly.points, "blue", poly.polygon_name)
    );
  };

  const getPolygonCenter = (points) => {
    const x = points.reduce((sum, p) => sum + p[0], 0) / points.length;
    const y = points.reduce((sum, p) => sum + p[1], 0) / points.length;
    return [x, y];
  };

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    drawAllPolygons();
    if (drawingEnabled && currentPolygon.length > 0) {
      drawPreviewPolygon(currentPolygon);
    }
  }, [polygons, currentPolygon]);

  const handleSubmit = async () => {
    if (polygons.length === 0) {
      alert("Please draw at least one polygon");
      return;
    }
    try {
      // https://visionqueuewaitingapi.greymatterz.com/seat-monitoring/register_camera
      const camera_url = localStorage.getItem("rtsp_url");
      const payload = {
        event_name: Eventname,
        camera_id: id?.id,
        camera_url: camera_url,
        usecase_id: useCaseId,
        coordinates: polygons,
      };

      console.log("Payload:", payload);
      const eventResponse = await setEventRecord(payload);
      if (eventResponse?.data?.status) {
        toast.success("Event saved successfully!");
      } else toast.error("Something went wrong!");
      //   const data = await axios.post(
      //     "https://visionqueuewaitingapi.greymatterz.com/seat-monitoring/register_camera",

      //     payload
      //   );
      //   console.log("data", data);
      //   localStorage.setItem("video_feed_url", data?.data?.video_feed_url);
      //   if (data) {
      //     toast.success("Event created successfully!!");
      //   }
      //   alert("Payload sent! Check console.");

      setPolygons([]);
      setCurrentPolygon([]);
      setShowModal(false);
      setName("");
      setDrawingEnabled(false);
      setPolygonCount(1);
    } catch (error) {
      console.log("error", error);
    }
  };

  return (
    <>
      <div className="entranceGroup">
        <IoIosArrowBack size={22} /> Camera / Entrance Group
      </div>

      <div className="container mt-5">
        <div className="image-area-wrapper">
          <div
            className="image-container"
            ref={imageRef}
            style={{ position: "relative", width: "960px", height: "540px" }}
          >
            <img
              src={`https://visionemptrack.greymatterz.com/stream2/stream2/${
                id.id
              }?t=${Date.now()}`}
              alt="Camera Feed"
              width={960}
              height={540}
            />
            <canvas
              ref={canvasRef}
              width={960}
              height={540}
              style={{ position: "absolute", top: 0, left: 0 }}
              onMouseDown={handleMouseDown}
              onMouseMove={handleMouseMove}
            />
          </div>

          <div className="button-group mt-3">
            <button className="action-btn" onClick={() => setShowModal(true)}>
              Add Event
            </button>
          </div>
        </div>
      </div>

      {showModal && (
        <div className="event-drawer">
          <div className="event-header">
            <span>
              <FaCalendar /> Polygon Event
            </span>
            <button onClick={() => setShowModal(false)}>✕</button>
          </div>

          <div className="event-body">
            <label>Event Name</label>
            <input
              value={Eventname}
              onChange={(e) => setEventName(e.target.value)}
              placeholder="Enter Event name"
            />

            <label>Polygon Name</label>
            <input
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Enter polygon name"
            />

            <button
              className="draw-btn mt-2"
              onClick={() => {
                setDrawingEnabled(true);
                setCurrentPolygon([]);
              }}
            >
              🔺 Click to draw polygon on video
            </button>

            <label className="form-label">UseCase</label>
            <select
              name="use_case"
              className="form-select"
              value={useCaseId}
              onChange={(e) => setUseCaseId(e.target.value)}
            >
              <option value="">Select</option>
              {useCase.map((ele) => (
                <option key={ele._id} value={ele._id}>
                  {ele.usecase_name}
                </option>
              ))}
            </select>
          </div>

          <div className="event-footer">
            <button className="cancel-btn" onClick={() => setShowModal(false)}>
              Cancel
            </button>
            <button className="submit-btn" onClick={handleSubmit}>
              Submit All
            </button>
          </div>
        </div>
      )}
    </>
  );
}

export default SetSeatdetection;
